export default "__VITE_ASSET__Fr_CQxUA__"